import { defaultState } from '@/store/modules/auth/state'
import router from '@/router'

export default {
  SET_INN_ORGANISATION_VALUE(state, payload) {
    state.innOrganisation = payload
  },
  SET_OKPO_VALUE(state, payload) {
    state.okpo = payload
  },
  SET_INN_USER_VALUE(state, payload) {
    state.innUser = payload
  },
  RESET_AUTH_STATE(state) {
    Object.assign(state, defaultState())
  },
  SET_LOADING_VERIFY_PIN(state, data) {
    state.loading.verifyPin = data
  },
  CLEAR_AUTH(state) {
    state.nextStep = ''
    state.innOrganisation = ''
    state.okpo = ''
    state.innUser = ''
  },
  LOGIN_SUCCESS(state, payload) {
    state.response.login = payload
    state.isAdmin = payload.isAdmin
    state.errors.pin = ''
    localStorage.setItem('token', payload.result)
    sessionStorage.setItem('isCurator', payload.isAdmin)
    router.push('/main')
  },
  LOGIN_FALSE(state, error) {
    state.errors.pin = error
  },
  GET_ORGANISATION_NAME_SUCCESS(state, payload) {
    state.response.getOrganisationName = payload.result
    state.isAdmin = payload.result.isAdmin
    state.errors.getOrganisationName = ''
  },
  GET_ORGANISATION_NAME_ERROR(state, error) {
    state.errors.getOrganisationName = error
  },
  SET_LOADING_VERIFY_NAME(state, data) {
    state.loading.verifyName = data
  },
  SET_LOADING_VERIFY_ORG_NAME(state, data) {
    state.loading.verifyOrgName = data
  },
  GET_USER_NAME_SUCCESS(state, payload) {
    state.response.getUserName = payload.result
    state.errors.getUserName = ''
  },
  GET_USER_NAME_ERROR(state, error) {
    state.errors.getUserName = error
  },
  CLEAR_ORGANISATION_NAME_ERROR(state, payload) {
    state.errors.getOrganisationName = payload
  },
  CLEAR_USER_NAME_ERROR(state, payload) {
    state.errors.getUserName = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutations.js